jQuery( document ).ready( function( $ ) {
	// Custom js goes here...
} );